module.exports = __webpack_public_path__ + "static/media/FrutigerNeueLTW04-Black.35fd3f3d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/frutiger/FrutigerNeueLTW04-Black.eot
// module id = 640
// module chunks = 0